import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractCrudService } from '../service/abstract.crud.service';

@Injectable({
  providedIn: 'root'
})
export class EspecialidadeService extends AbstractCrudService {

  protected getBaseUrlPrivate(): string {
    return super.getBaseUrlPrivate() + 'especialidades';
  }

  protected getBaseUrlPublic(): string {
    return super.getBaseUrlPublic() + 'especialidades';
  }
}
